<label
    class="anc-checkbox"
    [class.anc-checkbox--disabled]="disabled()"
    [class.anc-checkbox--indeterminate]="indeterminate()"
>
    <input
        #input
        type="checkbox"
        class="anc-checkbox__input"
        [checked]="checked()"
        [disabled]="disabled()"
        [attr.aria-checked]="indeterminate() ? 'mixed' : checked()"
        (change)="onToggle($event)"
    />
    <span class="anc-checkbox__box" aria-hidden="true"></span>
    <span class="anc-checkbox__label" *ngIf="label()" translate>{{ label() }}</span>
    <ng-content></ng-content>
</label>
